import React from 'react';
import { Table } from 'antd';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { columns } from './datasource';

function PackageTable({
  items,
  loading,
  current,
  pageSize,
  onRowClick,
  total,
  onChange,
}) {
  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y, x: '1200px' }}
      tableLayout="fixed"
      pagination={{
        current,
        total,
        pageSize,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { PackageTable };
